module.exports = __webpack_public_path__ + "img/logo.a5d4bf5a.png";